import React from "react";

export const ActivateIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M16.5007 8.44405C16.5007 8.56017 16.48 8.6727 16.4386 8.78164C16.3972 8.89059 16.3261 8.99268 16.2252 9.08792L9.2713 15.658C9.10421 15.8158 8.91226 15.8948 8.69545 15.8948C8.47865 15.8948 8.2867 15.8158 8.11959 15.658C7.9525 15.5001 7.86896 15.3214 7.86896 15.1217C7.86896 14.9221 7.9525 14.7434 8.11959 14.5855L13.812 9.2073L1.29202 9.2073C1.06278 9.2073 0.873585 9.13423 0.724433 8.98811C0.5753 8.84198 0.500732 8.66063 0.500732 8.44405C0.500732 8.22746 0.578065 8.04611 0.732728 7.89998C0.887391 7.75386 1.07934 7.68079 1.30858 7.68079L13.812 7.68079L8.11959 2.30259C7.9525 2.14471 7.86896 1.96597 7.86896 1.76636C7.86896 1.56674 7.9525 1.38799 8.11959 1.23011C8.2867 1.07225 8.47865 0.993318 8.69545 0.993318C8.91226 0.993318 9.10421 1.07225 9.2713 1.23011L16.2252 7.80017C16.3261 7.89541 16.3972 7.99587 16.4386 8.10156C16.48 8.20723 16.5007 8.3214 16.5007 8.44405Z"
      fill="white"
    />
  </svg>
);
